
export function init_forms() {
    
    // Set an input it's value on key up for label transition
    const FORM_INPUTS = document.getElementsByClassName('c-form__input');
    for (var i = 0; i < FORM_INPUTS.length; i++) {
        FORM_INPUTS[i].addEventListener('keyup', (e) => {
            e.currentTarget.setAttribute('value', e.currentTarget.value);
        });
    };

}


// WEBPACK FOOTER //
// ./resources/assets/js/scripts/form.js